import { type FC } from 'react';

import { MultiDecisionPanel } from '@widgets/merchant';

const BottomMenu: FC = () => <MultiDecisionPanel />;

export default BottomMenu;
